/** Prev/Next position of one finding within the list view's ordered id set,
 *  so the detail page can step through findings in the same order the
 *  practitioner sees them. Pure + exported so the boundary + not-found cases
 *  are unit-tested without the route.
 *
 *  When the current id isn't in the order (the filter changed since, or the
 *  page was deep-linked), `index` is -1 and both neighbours are null — the
 *  UI hides the controls and falls back to Back. */
export interface FindingNeighbors {
  index: number; // 0-based position, or -1 when not in the order
  total: number;
  prevId: string | null;
  nextId: string | null;
}

export function findingNeighbors(order: readonly string[], currentId: string): FindingNeighbors {
  const index = order.indexOf(currentId);
  if (index === -1) {
    return { index: -1, total: order.length, prevId: null, nextId: null };
  }
  return {
    index,
    total: order.length,
    prevId: index > 0 ? order[index - 1] : null,
    nextId: index < order.length - 1 ? order[index + 1] : null,
  };
}
